import { render, staticRenderFns } from "./ParamScaleEdit.vue?vue&type=template&id=d9bceffe&scoped=true"
import script from "./ParamScaleEdit.vue?vue&type=script&lang=js"
export * from "./ParamScaleEdit.vue?vue&type=script&lang=js"
import style0 from "./ParamScaleEdit.vue?vue&type=style&index=0&id=d9bceffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bceffe",
  null
  
)

export default component.exports